<template>

    <div v-if="dataStore.showMediaPopup" id="media-pop-up" class="general-popup">

        <!-- @click="closeMe($event)"  -->

        <div class="wrapper" :class="[dataStore.questionType, dataStore.activeType]">

            <span class="close-popup" v-on:click.prevent="globalFunctions.toggleAddMedia"><i class="fas fa-times"></i></span>

            <fragment v-if="dataStore.questionType === 'goodbad'">

                <h3 v-if="!dataStore.editMode" v-html="dataStore.activeType === 'map' ? language.add_map_type_title : language.add_image_type_title"></h3>

                <h3 v-if="dataStore.editMode" v-html="dataStore.activeType === 'map' ? language.change_map_type_title : language.change_image_type_title"></h3>

                <div v-if="['map', 'image'].includes(dataStore.activeType)" class="short-description">
                    <p v-html="dataStore.activeType === 'map' ? language.add_map_type_info : language.add_image_type_info"></p>
                </div>

            </fragment>

            <fragment v-if="dataStore.questionType === 'scale'">

                <h3 v-html="dataStore.editMode ? language.change_scale_type_title : language.add_scale_type_title"></h3>

                <div class="short-description">
                    <p v-html="language.add_scale_type_info"></p>
                </div>

                <div class="choices item-type">

                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="question" id="question" v-model="dataStore.activeType" value="question" :checked="'question' == dataStore.activeType">
                        <label class="form-check-label" for="question">
                            {{ language.add_type_option_none }}
                        </label>
                    </div>

                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="image" id="image" v-model="dataStore.activeType" value="image" :checked="'image' == dataStore.activeType">
                        <label class="form-check-label" for="image">
                            {{ language.add_type_option_image }}
                        </label>
                    </div>

                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="video" id="video" v-model="dataStore.activeType" value="video" :checked="'video' == dataStore.activeType">
                        <label class="form-check-label" for="video">
                            {{ language.add_type_option_video }}
                        </label>
                    </div>

                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="3d" id="3d" v-model="dataStore.activeType" value="3D" :checked="'3D' == dataStore.activeType">
                        <label class="form-check-label" for="3d">
                            {{ language.add_type_option_iframe }}
                        </label>
                    </div>

                </div>

            </fragment>

            <fragment v-if="dataStore.questionType === 'freetext'">

                <h3 v-html="dataStore.editMode ? language.change_freetext_type_title : language.add_freetext_type_title"></h3>

                <div class="short-description">
                    <p v-html="language.add_freetext_type_info"></p>
                </div>

                <div class="choices item-type">

                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="question" id="question" v-model="dataStore.activeType" value="question" :checked="'question' == dataStore.activeType">
                        <label class="form-check-label" for="question">
                            {{ language.add_type_option_none }}
                        </label>
                    </div>

                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="image" id="image" v-model="dataStore.activeType" value="image" :checked="'image' == dataStore.activeType">
                        <label class="form-check-label" for="image">
                            {{ language.add_type_option_image }}
                        </label>
                    </div>

                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="video" id="video" v-model="dataStore.activeType" value="video" :checked="'video' == dataStore.activeType">
                        <label class="form-check-label" for="video">
                            {{ language.add_type_option_video }}
                        </label>
                    </div>

                    <div class="form-check">
                        <input class="form-check-input" type="radio" name="3d" id="3d" v-model="dataStore.activeType" value="3D" :checked="'3D' == dataStore.activeType">
                        <label class="form-check-label" for="3D">
                            {{ language.add_type_option_iframe }}
                        </label>
                    </div>

                </div>

            </fragment>

            <good-bad v-if="dataStore.questionType === 'goodbad'" />

            <scale v-if="dataStore.questionType === 'scale'" />

            <freetext v-if="dataStore.questionType === 'freetext'" />

        </div>

    </div>

</template>

<script>

import dataStore from "../../store";
import globalFunctions from "../../globalFunctions";

import GoodBad from './../question-type/GoodBad';
import Scale from './../question-type/Scale';
import Freetext from './../question-type/Freetext';

import { Fragment } from 'vue-fragment'


export default {

    components: {
        GoodBad,
        Scale,
        Freetext,
        Fragment
    },

    data() {
        return {
            dataStore,
            globalFunctions,
        }
    },

    inject: [ 'language' ],

    methods: {
        closeMe: function(e) {
            if(e.target.classList.contains('general-popup')) {
                this.dataStore.showMediaPopup = false
            }
        }
    }
};
</script>
